import { PROCESS_TYPE, PROJECT, PROJECT_TYPE } from 'src/shared/constants/constants'
import {
  ALL_MILESTONE_CANTONAL_SUPPORT,
  ALL_MILESTONE_STATUSES_AFTER_SUPPORT,
  MILESTONE_CANTONAL_SUPPORT_TYPE,
  MILESTONE_STATUS_AFTER_SUPPORT_TYPE,
  MILESTONE_TYPE,
  MILESTONE_TYPE_TYPE,
} from 'src/shared/constants/milestone-constants'
import { Milestone, Milestone_Config, Milestone_Config_Bool_Exp, Query_Root } from 'src/@types/graphql'
import { SupportedLocale } from 'src/@types'
import { queryMilestoneConfigurationDescription } from 'src/screens/administration/configuration-management/milestones-configuration/milestoneConfigQuerties'
import { Client } from 'urql'

export const fetchMilestoneConfigsForProcessAndType = (
  process: PROCESS_TYPE,
  type: MILESTONE_TYPE_TYPE | undefined,
  urqlClient: Client,
) => {
  const milestoneConfigCondition: Milestone_Config_Bool_Exp = { _and: [] }

  milestoneConfigCondition._and?.push({ process: { _eq: process } })

  if (type !== undefined) {
    milestoneConfigCondition._and?.push({ type: { _eq: type } })
  }

  return urqlClient.query<
    {
      milestone_config: Query_Root['milestone_config']
    },
    {
      milestoneConfigCondition: Milestone_Config_Bool_Exp
    }
  >(queryMilestoneConfigurationDescription, { milestoneConfigCondition: milestoneConfigCondition })
}

export const getMilestoneTitle = (milestoneConfig: Milestone_Config | undefined, locale: SupportedLocale): string => {
  if (milestoneConfig === undefined) {
    return ``
  }

  return milestoneConfig.description[locale] ?? ''
}

export const getMilestoneSummaryTitleLabel = (process: PROJECT_TYPE, milestoneType: string) => {
  return process === PROJECT.KAP && milestoneType === MILESTONE_TYPE.FINAL_REPORT
    ? `label.program.milestone.summary.title.${milestoneType}`
    : `label.milestone.summary.title.${milestoneType}`
}

export const sortMilestoneStatusesAfterSupport = (
  statues: MILESTONE_STATUS_AFTER_SUPPORT_TYPE[],
): MILESTONE_STATUS_AFTER_SUPPORT_TYPE[] =>
  statues.sort(
    (a, b) => ALL_MILESTONE_STATUSES_AFTER_SUPPORT.indexOf(a) - ALL_MILESTONE_STATUSES_AFTER_SUPPORT.indexOf(b),
  )

export const sortMilestoneCantonalSupport = (
  statues: MILESTONE_CANTONAL_SUPPORT_TYPE[],
): MILESTONE_CANTONAL_SUPPORT_TYPE[] =>
  statues.sort((a, b) => ALL_MILESTONE_CANTONAL_SUPPORT.indexOf(a) - ALL_MILESTONE_CANTONAL_SUPPORT.indexOf(b))

export function sortMilestonesContractFirstFinalReportLast(milestones: Milestone[]): Milestone[] {
  let contract: Milestone | undefined
  let finalReport: Milestone | undefined

  const others: Milestone[] = []

  for (const m of milestones) {
    if (m.type === MILESTONE_TYPE.CONTRACT) {
      contract = m
    } else if (m.type === MILESTONE_TYPE.FINAL_REPORT) {
      finalReport = m
    } else {
      others.push(m)
    }
  }

  return [...(contract ? [contract] : []), ...others, ...(finalReport ? [finalReport] : [])]
}
